import { combineReducers } from 'redux';
import catalog from './catalog';
import item from './item';

const reducer = combineReducers({
  catalog, item,
});
export default reducer;